(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.formly.inputs.service.media-processor-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../../../api')
    ])
    .factory('MediaProcessor', mediaProcessor)

  mediaProcessor.$inject = ['SdkConfig', 'ThismomentApi']
  function mediaProcessor (SdkConfig, ThismomentApi) {
    var actions = {
      process: {
        method: 'POST',
        transformResponse: function (data, headers, status) {
          return {
            data: JSON.parse(data),
            headers: headers(),
            status: status
          }
        },
        isArray: false
      }
    }

    return ThismomentApi.configureResource(SdkConfig.get('file_processor_url'), {}, actions)
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/service/media-processor.js